import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TriToggleComponent } from './tri-toggle.component';

@NgModule({
  declarations: [
    TriToggleComponent
  ],
  imports: [
    CommonModule,

		FormsModule,
  ],
	exports: [
		TriToggleComponent,
	],
})
export class TriToggleModule { }
